// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BZ2_GRID_WATCHDOG_FILTER_SAVED_WITH_unsubscribe = "Toto h\u013eadanie m\u00e1\u0161 ulo\u017een\u00e9. Ak u\u017e nechce\u0161 dost\u00e1va\u0165 e-maily, %(unsubscribe)s.";
export const BZ2_GRID_WATCHDOG_SAVE_FILTER = "Ulo\u017e h\u013eadanie";
export const BZ2_GRID_WATCHDOG_SAVE_FILTER_MESSAGE = "<strong>Ulo\u017e si toto h\u013eadanie</strong> a my ti po\u0161leme e-mail, ke\u010f niekto prid\u00e1 inzer\u00e1t.";
export const BZ2_GRID_WATCHDOG_UNSUBSCRIBE = "zru\u0161 ulo\u017eenie";
